// extracted by mini-css-extract-plugin
export default {"inputWrapper":"password_inputWrapper__YMLxh","label":"password_label__eL3RQ","dark":"password_dark__+yV7r","input":"password_input__kqQ9T","errorText":"password_errorText__Y+hUS"};